import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ArrowLeft from '../../../Icons/ArrowLeft/ArrowLeft';
import { IconSize } from '../../../Icons/IconWrap';
import { BiEventType } from '../../../biLogger/constants';
import BiButton from '../../../biLogger/Components/SimpleBiButton';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ArtStageArrowL from '../../../Icons/ArtStageArrowL';
import s from './BackToStreamButton.scss';
var BackToStreamButton = function (_a) {
    var className = _a.className, exitDuperbrowse = _a.exitDuperbrowse, parent = _a.parent, deviation = _a.deviation;
    var t = useTranslation().t;
    if (!parent) {
        return null;
    }
    return (React.createElement(BiButton, { biData: {
            evid: BiEventType.BACK_TO_CLICK,
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation),
            link_url: parent.url,
            next_itemid: parent.itemId,
            next_typeid: parent.typeId,
        }, className: classnames(s['duperexit'], className), onClick: exitDuperbrowse }, parent.title ? (React.createElement(React.Fragment, null,
        React.createElement(ArtStageArrowL, { customSizable: true, className: s['small-icon'] }),
        React.createElement("div", { className: classnames(s['back'], s['with-title']) }, t('deviation.duperbrowse.backTo')),
        React.createElement("div", { className: s['back-to'] }, parent.title))) : (React.createElement("div", { className: s['back'] },
        React.createElement(ArrowLeft, { size: IconSize.SMALL }),
        t('deviation.duperbrowse.back')))));
};
BackToStreamButton.displayName = 'BackToStreamButton';
export default BackToStreamButton;
//# sourceMappingURL=BackToStreamButton.js.map